import React from "react";
import {ConfigProvider, Rate } from "antd";

import useTranslation from "utils/hooks/useTranslation";

interface RateLineProps {
    name: string;
    description?: string;
    value: number;
    onChange: (value: number) => void;
    disabled?: boolean;
}

export const RateLine: React.FC<RateLineProps> = ({ name, description, value, onChange, disabled = false }) => {
    const { t } = useTranslation();

    return <>
        <group data-gap="20">
            <group data-length="autofit" data-direction="column">
                <text data-weight="300" data-text-size="large" data-color="grey-color-dark">
                    <i data-color="red" data-space-right="10">•</i>{t(name)} {description && ` ${description}`}:
                </text>
            </group>
        </group>
        <group data-gap="20">
            <group data-width="auto" data-text-size="40" data-space-horizontal="15" data-direction="column">
                <ConfigProvider
                    theme={{
                        components: {
                        Rate: {
                            starSize: 30,
                            starColor: '#f26f5f',
                            starBg: '#E6E6E6'
                        },
                        },
                    }}
                >
                    <Rate value={value} onChange={onChange} disabled={disabled} />
                </ConfigProvider>
            </group>
        </group>
    </>
}

interface RatesSatisfactionProps {
    values: Record<string, number>;
    onChange: (name: string, value: number) => void;
}

export const RatesSatisfaction: React.FC<RatesSatisfactionProps> = ({values, onChange}) => {
    const { t } = useTranslation();

    const fields = [
        { name: "ACCESS_FACILITY", description: t("ACCESS_FACILITY_PLUS") },
        { name: "ERGONOMY" },
        { name: "SIMPLICITY" },
        { name: "INTUITIVENESS" },
        { name: "FIABILITY" },
        { name: "RAPIDITY" },
        { name: "LISIBILITY" },
        { name: "INFORMATIONS" },
        { name: "DESIGN" },
    ];

    return (
        <>
        {fields.map(({ name, description }) => (
            <RateLine
                key={name}
                name={name}
                description={description}
                value={values[name] || 0}
                onChange={(val) => onChange(name, val)}
            />
        ))}
        </>
    )
}